<template>

    <div id='page'>   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>OT Agenda</h1>			
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
    	<div id='content1'>   
			<div class="calendar round-small shadow-small">
				<div class="cal-header">
					<h4 class="cal-title center-text uppercase bolder bg-orange-light"><a href="#" @click="displaycalendario" class="color-white">{{ fechaextendida }}, {{ sucursal }}</a></h4>
					<h6 class="cal-title-left bolder"><a href="#" @click="previouscalendar"><i class="color-white fa fa-chevron-left"></i></a></h6>
					<h6 class="cal-title-right bolder"><a href="#" @click="nextcalendar"><i class="color-white fa fa-chevron-right"></i></a></h6>
				</div>
				<div class="clear"></div>
				<div  v-if="vercalendario" class="cal-days bg-dark2-light opacity-80 bottom-0">
					<a href="#">LU</a>
					<a href="#">MA</a>
					<a href="#">MI</a>
					<a href="#">JU</a>
					<a href="#">VI</a>
					<a href="#">SA</a>
					<a href="#">DO</a>
					<div class="clear"></div>
				</div>
				<div v-if="vercalendario" v-for="(c, index) in calendario" class="cal-dates cal-dates-border">
					<a v-if="c.selected" href="#" @click="getcalendario(c.fecha)" class="cal-selected"><i class="fa fa-square"></i><span>{{ c.dia }}</span></a>
					<a v-else-if="c.disabled" href="#" class="cal-disabled">{{ c.dia }}</a>
					<a v-else-if="!c.selected" href="#" @click="getcalendario(c.fecha)">{{ c.dia }}
					</a>
					<div v-else-if="c.end" class="clear"></div>
				</div>
			
			</div>


			<div class="calendar">
				<div class="search-box search-color bg-orange-light shadow-tiny round-huge bottom-0">
					<i class="fa fa-search"></i>
					<input type="text" v-model="datasearch" @keyup="datasearchfx(0,false)" placeholder="Buscar por patente y/o cliente" data-search>
					<button class="button button-s shadow-small button-circle bg-magenta1-dark" @click="datasearchfx(102,false)">Creación ({{ cantidadcreacion }}) </button>
					<button class="button button-s shadow-small button-circle bg-red2-dark" @click="datasearchfx(113,false)">Ejecución ({{ cantidadejecucion }})</button>
					<button class="button button-s shadow-small button-circle bg-green1-dark" @click="datasearchfx(116,false)">Lig.No.Pagada ({{ cantidadliquidadanopagada }})</button>
				</div>
			</div>

			<div class="divider bottom-15"></div>
			
		
		<div id="menu-email" class="menu menu-box-bottom menu-box-detached round-medium" data-menu-height="290" data-menu-effect="menu-over">
					<div id="menu-emailcontent" class="content">
						<h1 class="uppercase ultrabold top-20">Envío de Trabajos por Email</h1>
						<form id="formemail">
							<span id="r_txtemail" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Requerido</span>
							<span id="e_txtemail" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">El formato de e-mail es incorrecto</span>
							<div class="input-style has-icon input-style-1 input-required">
								<span>Email</span>
								<em>(requerido)</em>
								<input id="txtemail" type="email" placeholder="Email">
							</div>
			
							<div class="clear"></div>
							<a href="#" @click="enviarmailtrabajos()" class="button button-full button-s shadow-large button-round-small bg-blue2-dark top-10">Enviar e-mail</a>
							<div class="top-20 bottom-20">
								<a href="#" data-menu="salir" class="center-text font-11 color-gray2-dark">Para cancelar presione aquí</a>
							</div>
						</form>

					</div>

					<div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark" style="display:none">
						<i class="fa fa-check"></i>
						<strong class="uppercase ultrabold">Success</strong>
						<span>Everything's okay here</span>
						<i data-menu="salir" class="fa fa-times"></i>
					</div>  

			</div> 

			<div id="menu-whatsapp" class="menu menu-box-bottom menu-box-detached round-medium" data-menu-height="290" data-menu-effect="menu-over">
					<div class="content">
						<h1 class="uppercase ultrabold top-20">Envío de Trabajos por Whatsapp</h1>
						<form id="formwhatsapp">
							<span id="r_txtfonowhatsapp" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Requerido</span>
							<div class="input-style has-icon input-style-1 input-required">
								<span>Teléfono</span>
								<em>(requerido)</em>
								<input id="txtfonowhatsapp" type="text" maxlength="11" placeholder="Teléfono">
							</div>
			
							<div class="clear"></div>
							<a href="#" @click="enviarwhatsapptrabajos()" class="button button-full button-s shadow-large button-round-small bg-green2-dark top-10">Enviar Whatsapp</a>
							<div class="top-20 bottom-20">
								<a href="#" data-menu="salir" class="center-text font-11 color-gray2-dark">Para cancelar presione aquí</a>
							</div>

						</form>

					</div>

					<div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark" style="display:none">
						<i class="fa fa-check"></i>
						<strong class="uppercase ultrabold">Success</strong>
						<span>Everything's okay here</span>
						<i data-menu="salir" class="fa fa-times"></i>
					</div>  

			</div> 


		<div class="content-boxed">
				<div v-for="(a, index) in agenda" class="content">
					<div class="user-list-slider bottom-0">
						<div v-if="a.iscrearpauta" class="user-list-right">
							<h4 style="top:12px;left:10px">{{ a.fecha }} {{ a.hora }} {{ a.CLIENTEAGENDA }}</h4>
							<p class="color-magenta1-dark" style="font-size:1.5em;top:30px;left:10px">{{ a.PLACAPATENTE}}</p>

							<a href="#" @click="fechaentrega(a.IN_COD_COTIZACIONVEHICULO)" class="chip chip-small bg-gray1-dark" style="left:-80px;top:-20px">
							<i class="fas fa-calendar-check bg-magenta1-dark"></i>
								<span class="color-black">Entrega {{ a.fechaentrega}}</span>
							</a>
							<a href="#" @click="enviarwhatsapp(a.CLIENTEFONO)" class="chip chip-small bg-gray1-dark" style="left:-80px;top:-20px">
							<i class="fab fa-whatsapp bg-green2-dark"></i>
								<span class="color-green2-dark">Whatsapp</span>
							</a>

							<span class="next-slide-user fa-1x bg-magenta1-dark" style="width:150px;top:-20px">{{ a.ESTADO }} N° {{ a.IN_COD_COTIZACIONVEHICULO }}</span>
							<br>	
							
							<a href="#" @click="VerImagenesOT(a.IN_COD_COTIZACIONVEHICULO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fas fa-image bg-yellow2-dark"></i>
								<span class="color-black">Imagenes</span>
							</a>

							<a href="#" @click="ImprimirOT(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-print bg-red2-dark"></i>
								<span class="color-red2-dark">Imprimir</span>
							</a>
							<a href="#" @click="VerOTInterna(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-file bg-red3-light"></i>
								<span class="color-red3-light">Cartón</span>
							</a>

							<a href="#" @click="setdatamail(a.IN_COD_COTIZACIONVEHICULO,a.CLIENTEEMAIL)" data-menu="menu-email" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-envelope bg-blue2-dark">&nbsp; {{ a.NUMEROENVIOSEMAIL }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a>

							<a href="#" @click="setdatawhatsapp(a.IN_COD_COTIZACIONVEHICULO,a.IN_COD_USUARIOAGENDA,a.CLIENTEFONO)" data-menu="menu-whatsapp" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fab fa-whatsapp bg-green2-dark">&nbsp; {{ a.NUMEROENVIOSWHATSAPP }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a>

							<a href="#" @click="ReciboConformidad(a.IN_COD_COTIZACIONVEHICULO, a.IDEXTERNO)" data-menu="menu-ReciboConformidad" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-file bg-blue2-dark"></i>
								<span class="color-black">Recibo de Conformidad</span>
							</a>

							<br>
							<br>

						</div>

						<div v-else-if="a.isejecucion" class="user-list-right">
							<h4 style="top:12px;left:10px">{{ a.fecha }} {{ a.hora }} {{ a.CLIENTEAGENDA }}</h4>
							<p class="color-red2-dark" style="font-size:1.5em;top:30px;left:10px">{{ a.PLACAPATENTE}}</p>

							<a href="#" @click="fechaentrega(a.IN_COD_COTIZACIONVEHICULO)" class="chip chip-small bg-gray1-dark" style="left:-80px;top:-20px">
							<i class="fas fa-calendar-check bg-red2-dark"></i>
								<span class="color-black">Entrega {{ a.fechaentrega}}</span>
							</a>
							<a href="#" @click="enviarwhatsapp(a.CLIENTEFONO)" class="chip chip-small bg-gray1-dark" style="left:-80px;top:-20px">
							<i class="fab fa-whatsapp bg-green2-dark"></i>
								<span class="color-green2-dark">Whatsapp</span>
							</a>


							<span class="next-slide-user fa-1x bg-red2-dark" style="width:150px;top:-20px">{{ a.ESTADO }} N° {{ a.IN_COD_COTIZACIONVEHICULO }}</span>
							<br>

							<a href="#" @click="VerImagenesOT(a.IN_COD_COTIZACIONVEHICULO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fas fa-image bg-yellow2-dark"></i>
								<span class="color-black">Imagenes</span>
							</a>

							<a href="#" @click="ImprimirOT(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-print bg-red2-dark"></i>
								<span class="color-red2-dark">Imprimir</span>
							</a>
							<a href="#" @click="VerOTInterna(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-file bg-red3-light"></i>
								<span class="color-red3-light">Cartón</span>
							</a>

							<a href="#" @click="setdatamail(a.IN_COD_COTIZACIONVEHICULO,a.CLIENTEEMAIL)" data-menu="menu-email" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-envelope bg-blue2-dark">&nbsp; {{ a.NUMEROENVIOSEMAIL }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a>

							<a href="#" @click="setdatawhatsapp(a.IN_COD_COTIZACIONVEHICULO,a.IN_COD_USUARIOAGENDA,a.CLIENTEFONO)" data-menu="menu-whatsapp" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fab fa-whatsapp bg-green2-dark">&nbsp; {{ a.NUMEROENVIOSWHATSAPP }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a>

							<!-- <a href="#" @click="VerReciboConformidad(a.IDEXTERNO)" data-menu="menu-ReciboConformidad" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-file bg-blue2-dark"></i>
								<span class="color-black">Recibo de Conformidad</span>
							</a> -->

							<a href="#" @click="ReciboConformidad(a.IN_COD_COTIZACIONVEHICULO, a.IDEXTERNO)" data-menu="menu-ReciboConformidad" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-file bg-blue2-dark"></i>
								<span class="color-black">Recibo de Conformidad</span>
							</a>

							<br>
							<br>

						</div>

						<div v-else-if="a.isliqnopagada" class="user-list-right">
							<h4 style="top:12px;left:10px">{{ a.fecha }} {{ a.hora }} {{ a.CLIENTEAGENDA }}</h4>
							<p class="color-green1-dark" style="font-size:1.5em;top:30px;left:10px">{{ a.PLACAPATENTE}}</p>

							<a href="#" @click="enviarwhatsapp(a.CLIENTEFONO)" class="chip chip-small bg-gray1-dark" style="left:-80px;top:-20px">
							<i class="fab fa-whatsapp bg-green2-dark"></i>
								<span class="color-green2-dark">Whatsapp</span>
							</a>

							<a href="#" @click="ImprimirOT(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark" style="left:-80px;top:-20px">
							<i class="fa fa-print bg-red2-dark"></i>
								<span class="color-red2-dark">Imprimir</span>
							</a>
							<a href="#" @click="VerOTInterna(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark" style="left:-80px;top:-20px">
							<i class="fa fa-file bg-red3-light"></i>
								<span class="color-red3-light">Cartón</span>
							</a>

							<span class="next-slide-user fa-1x bg-green1-dark" style="width:150px;top:-20px">{{ a.ESTADO }} N° {{ a.IN_COD_COTIZACIONVEHICULO }}</span>
							<br>
									
							<a href="#" @click="VerImagenesOT(a.IN_COD_COTIZACIONVEHICULO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fas fa-image bg-yellow2-dark"></i>
								<span class="color-black">Imagenes</span>
							</a>

							<a href="#" @click="ImprimirOT(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-print bg-red2-dark"></i>
								<span class="color-red2-dark">Imprimir</span>
							</a>
							<a href="#" @click="VerOTInterna(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-file bg-red3-light"></i>
								<span class="color-red3-light">Cartón</span>
							</a>

							<a href="#" @click="setdatamail(a.IN_COD_COTIZACIONVEHICULO,a.CLIENTEEMAIL)" data-menu="menu-email" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-envelope bg-blue2-dark">&nbsp; {{ a.NUMEROENVIOSEMAIL }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a>

							<a href="#" @click="setdatawhatsapp(a.IN_COD_COTIZACIONVEHICULO,a.IN_COD_USUARIOAGENDA,a.CLIENTEFONO)" data-menu="menu-whatsapp" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fab fa-whatsapp bg-green2-dark">&nbsp; {{ a.NUMEROENVIOSWHATSAPP }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a>

							<!-- <a href="#" @click="VerReciboConformidad(a.IDEXTERNO)" data-menu="menu-ReciboConformidad" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-file bg-blue2-dark"></i>
								<span class="color-black">Recibo de Conformidad</span>
							</a> -->

							<a href="#" @click="ReciboConformidad(a.IN_COD_COTIZACIONVEHICULO, a.IDEXTERNO)" data-menu="menu-ReciboConformidad" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-file bg-blue2-dark"></i>
								<span class="color-black">Recibo de Conformidad</span>
							</a>

							<br>
							<br>
						</div>


					</div>   


					<div class="divider bg-gray2-dark"></div>

				
				</div>
			<br>

			</div>   
    	</div>

		
    </div>

</template>

<script>

import * as db from "../../database.js";
import * as validate from "../../validate.js";

export default {
    data() {
      return {
		idcotizacionvehiculo:0,
		idagenda:0,
		idFile:Math.floor(Math.random() * 10000),

		datasearch:"",
		datasearchcodestado:0,

		strFecha:"",
		fechaextendida:"",
		mescalendario:"",
		datasearch:"",
		codsucursal:0,
		sucursal:"",
        agenda: [],
        calendario: [],
		response: "",
		response: "",
		cantidadcreacion:0,
		cantidadejecucion:0,
		cantidadliquidadanopagada:0,
		vercalendario:false

      }
    },

	created() {      
		this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")"  
		this.idcotizacionvehiculo=0;
		this.idagenda=0;
		this.codusuario=JSON.parse(localStorage.getItem('user')).codusuario;

		this.strFecha=db.Now();
		this.sucursal=JSON.parse(localStorage.getItem('user')).sucursal;
  		this.codsucursal=JSON.parse(localStorage.getItem('user')).codsucursal;

		this.getcalendario(this.strFecha);
		//this.getagenda(this.strFecha)
		this.datasearchfx(0,true);
	},


  methods: {
	displaycalendario(){
		this.vercalendario=!this.vercalendario;		
	},	

	getcalendario(strFecha) {
		
		this.strFecha=strFecha;

		db.getFx("agenda.getcalendario",'{"fecha":"'+strFecha+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err); }else{
			this.calendario=result.data.data
    		this.getagenda(strFecha)
		}});
	},
    getagenda(strFecha) {

		this.mescalendario=db.Mescalendario(this.strFecha);
		this.fechaextendida=db.Fechaextendida(this.strFecha);

		var intcodestado=this.datasearchcodestado;	
		this.datasearchfx(0,true);
		if (intcodestado>0)
			this.datasearchfx(intcodestado,false);	

		this.datasearchcodestado=intcodestado;	
//db.getFx("agenda.seleccionhora",'{"fecha":"'+strFecha+'","codsucursal":"'+this.codsucursal+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
		//	console.log(result.data.data)
		//	this.agenda=result.data.data
		// }});

	},

	datasearchfx(codestado,blnConCantidades){
		let codsucursal=JSON.parse(localStorage.getItem('user')).codsucursal;
		let codusuario=JSON.parse(localStorage.getItem('user')).codusuario;
		this.agenda=[];
		this.datasearchcodestado=codestado;

		db.getFx3("agenda.seleccionhora",'{"datasearch":"'+this.datasearch+'","fecha":"'+this.strFecha+'","codsucursal":"'+codsucursal+'","codestado":"'+codestado+'","codasesor":"'+codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			console.log(result.data.data)
			this.agenda=result.data.data
			if(blnConCantidades)
				{
				var i;
				this.cantidadcreacion=0;
				this.cantidadejecucion=0;
				this.cantidadliquidadanopagada=0;
				for(i=0;i<this.agenda.length;i++)
					{						
					if(this.agenda[i].iscrearpauta) this.cantidadcreacion++;
					if(this.agenda[i].isejecucion) this.cantidadejecucion++;
					if(this.agenda[i].isliqnopagada) this.cantidadliquidadanopagada++;
					}
				}
			}});

		},

	nextcalendar(){
		if(this.vercalendario)
			this.calendaraddmonth(1)
		else
			this.calendaraddday(1)

		this.getcalendario(this.strFecha);
	},
	previouscalendar(){
		if(this.vercalendario)
			this.calendaraddmonth(-1)
		else
			this.calendaraddday(-1)

		this.getcalendario(this.strFecha);
	},

	calendaraddmonth(add){
		let date = new Date()
		let day=1
		let month = parseInt(this.strFecha.substring(3,5))+add
		let year = parseInt(this.strFecha.substring(6,10))

		if(date.getMonth() + add==month)
			day = date.getDate()

		if(month==0){
			month = 12
			year =year+add
			}

		if(month==13){
			month = 12
			year =year+add
			}

		if(month < 10) month="0"+month; 
		if(day < 10) day="0"+day; 
		this.strFecha=day+"/"+month+"/"+year;
	},

	calendaraddday(add){
		let date = new Date()
		let day=parseInt(this.strFecha.substring(0,2))
		let month = parseInt(this.strFecha.substring(3,5))
		let year = parseInt(this.strFecha.substring(6,10))

		date=new Date(year,month,day);
		date=new Date(date.getFullYear(),date.getMonth(),date.getDate()+add);

		year= date.getFullYear()
		month= date.getMonth()
		day= date.getDate()

		if(month < 10) month="0"+month; 
		if(day < 10) day="0"+day; 
		this.strFecha=day+"/"+month+"/"+year;
	},

	fechaentrega(codot) {
		localStorage.setItem('idcotizacionvehiculo',codot);
		window.location="/MisOTFechaentrega"
		},

	setdatamail(idcotizacionvehiculo,mail){
		document.getElementById("txtemail").value=mail;
		this.idcotizacionvehiculo=idcotizacionvehiculo;
		},

	setdatawhatsapp(idcotizacionvehiculo,idagenda,fono){
		document.getElementById("txtfonowhatsapp").value=fono;
		this.idcotizacionvehiculo=idcotizacionvehiculo;
		this.idagenda=idagenda;
		},


	enviarmailtrabajos(){
			var strErr=validate.check(formemail)
			if (strErr==""){

				db.getFx("ot.observacion",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","motivo":"Envío trabajos por email","obs":"'+ document.getElementById("txtemail").value +'","codasesor":"'+this.codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					db.getFx("ot.sendmail",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","codasesor":"'+this.codusuario+'","idfileemail":"'+ this.idFile+'","emailcliente":"'+ document.getElementById("txtemail").value +'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						this.datasearchfx(this.datasearchcodestado,true);
					}});
				}});
			}

		},
	enviarwhatsapptrabajos(){
			var strErr=validate.check(formwhatsapp)
			var strIDWhatsapp = db.getServerHTTP()+"/otprocess.aspx?id="+this.idagenda

			// Comprobar y reemplazar la URL si es necesario
			if (strIDWhatsapp.startsWith("http://puente.xxi.cl/")) {
				strIDWhatsapp = strIDWhatsapp.replace("http://puente.xxi.cl/", "http://xxi.netcar.cl/");
			}

			if (strIDWhatsapp.startsWith("http://puente.valenzueladelarze.cl/")) {
				strIDWhatsapp = strIDWhatsapp.replace("http://puente.valenzueladelarze.cl/", "http://vyd.netcar.cl/");
			}
			
			var txtTexto="Revise sus trabajos en este link: "+strIDWhatsapp
	
			if (strErr==""){
				db.getFx("ot.observacion",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","motivo":"Envío trabajos por whatsapp","obs":"'+ document.getElementById("txtfonowhatsapp").value +'","codasesor":"'+this.codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					db.getFx("ot.sendwhatsapptrabajos",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","codasesor":"'+this.codusuario+'","fono":"'+ document.getElementById("txtfonowhatsapp").value +'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						window.open("https://api.whatsapp.com/send?phone="+document.getElementById("txtfonowhatsapp").value+"&text="+txtTexto, "_blank");
						this.datasearchfx(this.datasearchcodestado,true);
					}});
				}});
			}
		},

	enviarwhatsapp(fono){
			window.open("https://api.whatsapp.com/send?phone="+fono, "_blank");
		},

	VerOTInterna(id){

		var url = db.getServerHTTP();

		if(url == "http://puente.xxi.cl/"){
			url = "https://xxi.netcar.cl";
		}

		if(url == "http://puente.valenzueladelarze.cl/"){
			url = "http://vyd.netcar.cl";
		}

		window.open(url + "/taller/tlrShowOTInterna.aspx?id="+id+"&file="+this.idFile+"'", "_blank");
	},
	
	ImprimirOT(id){

		var url = db.getServerHTTP();

		if(url == "http://puente.xxi.cl/"){
			url = "https://xxi.netcar.cl";
		}

		if(url == "http://puente.valenzueladelarze.cl/"){
			url = "http://vyd.netcar.cl";
		}
		
		window.open(url + "/taller/tlrShowOT2.aspx?id="+id+"&file="+this.idFile+"'", "_blank");

	},
	VerReciboConformidad(id){

		var url =db.getServerHTTP();

		if(url == "http://puente.xxi.cl/"){
			url = "https://xxi.netcar.cl";
		}

		if(url == "http://puente.valenzueladelarze.cl/"){
			url = "http://vyd.netcar.cl";
		}

		window.open(url+"/taller/tlrShowOTReciboconformidad.aspx?id="+id);
	},
	
	ReciboConformidad(id, idExterno) {
		  console.log(id)
		  console.log(idExterno)
		  localStorage.setItem('idcotizacionvehiculoReciboConformidad', id)
		  localStorage.setItem('idExternoReciboConformidad', idExterno)
		  window.location = "/ReciboConformidad"
	},
	VerImagenesOT(id) {
		  localStorage.setItem('idcotizacionvehiculo', id)
		  window.location = "/ImagenesOT"
	},
  }
}

/*
methods: {
		make_requests_handler() {
		this.message = 'Requests in progress'

		axios.all([
			this.request_1(), //or direct the axios request
			this.request_2()
		])
		.then(axios.spread((first_response, second_response) => {
			this.message = 'Request finished'
			this.first_request = 'The response of first request is' + first_response.data.message
			this.second_request = 'The response of second request is' + second_response.data.message
			}))
		},
		request_1() {
		this.first_request: 'first request began'
		return axios.get('you_URL_here')
		},
		request_2() {
		this.second_request: 'second request began'
		return axios.get('another_URL', { params: 'example' })
		},
	

      sendData() {
          var bodyFormData = new FormData();

          bodyFormData.set('userName', 'Fred');
          bodyFormData.set('userName2', 'Fred2');
          //bodyFormData.append('image', imageFile); 

          axios({ method: "POST", "url": "http://localhost:50130/http/test.aspx",data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}}).then(result => {
                    this.response = result.data;
                }, error => {
                    console.error(error);
                });


/*
this.$http.post("http://localhost:60742/api/test/2").then(result => {
      alert("resultdata");
          this.response = result.data;
        }, error => {
      alert("errorsend");
          console.error(error);
        });
      */
	 /*
      }
    }
  }
  */
</script>
